import { BreadcrumbsService } from './breadcrumbs.service';
var BreadcrumbsComponent = /** @class */ (function () {
    function BreadcrumbsComponent(service) {
        this.service = service;
    }
    Object.defineProperty(BreadcrumbsComponent.prototype, "parts", {
        get: function () {
            return this.service.parts;
        },
        enumerable: true,
        configurable: true
    });
    return BreadcrumbsComponent;
}());
export { BreadcrumbsComponent };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/components/breadcrumbs/breadcrumbs.component.ts.pre-build-optimizer.js